import React from "react";

interface CustomLoaderProps {
  color?: string;
  size?: number;
  type?: "round" | "splitter" | "dash";
}

const round = ({ size, color }: { size: number; color: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ stroke: color, fill: "none", strokeWidth: 2 }}
  >
    <circle cx="12" cy="12" r="10" strokeOpacity="0.2" />
    <path d="M12 2 A10 10 0 0 1 22 12" strokeLinecap="round">
      <animateTransform
        attributeName="transform"
        type="rotate"
        dur="1s"
        from="0 12 12"
        to="360 12 12"
        repeatCount="indefinite"
      />
    </path>
  </svg>
);

const splitter = ({ size, color }: { size: number; color: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fill: color }}
  >
    <g>
      {Array.from({ length: 12 }).map((_, i) => (
        <rect
          key={i}
          x="11"
          y="2"
          width="2"
          height="6"
          opacity={0.1 + i * 0.075}
          transform={`rotate(${i * 30} 12 12)`}
        />
      ))}
      <animateTransform
        attributeName="transform"
        type="rotate"
        dur="1.2s"
        from="0 12 12"
        to="360 12 12"
        repeatCount="indefinite"
      />
    </g>
  </svg>
);

const dash = ({ size, color }: { size: number; color: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ stroke: color, fill: "none", strokeWidth: 2 }}
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      strokeDasharray="15 47"
      strokeLinecap="round"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        dur="1.5s"
        from="0 12 12"
        to="360 12 12"
        repeatCount="indefinite"
      />
      <animate
        attributeName="stroke-dashoffset"
        dur="1.5s"
        values="0;-15;0"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
);

const CustomLoader: React.FC<CustomLoaderProps> = ({
  color = "#3b82f6", // Material blue-500 equivalent
  size = 24,
  type = "round",
}) => {
  const loaders = {
    round: round({ size, color }),
    splitter: splitter({ size, color }),
    dash: dash({ size, color }),
  };
  return loaders[type] || loaders["round"];
};

export default CustomLoader;
